import Color from "color";


// -- Colors

const swatch = {
    white: "#ffffff",
    grey: {
        lighter: "#F6F6F6",
        light: "#E6E6E6",
        base: "#939393",
        dark: "#666666",
        darker: "#212121",
    },
};

export const COLORS = {
    white: swatch.white,
    primary: {
        light: "#4868f7",
        base: "#1b43f5",
        dark: "#122eab",
    },
    secondary: {
        light: "#3f51a9",
        base: "#000182",
        dark: "#001056",
    },
    tertiary: {
        light: "#5793eb",
        base: "#031734",
        dark: "#010c1c",
    },
    quinary: {
        light: "#0ac48d",
        base: "#00b17c",
        dark: "#007f59",
    },
    success: {
        light: "#d1eedd",
        base: "#028526",
    },
    error: "#df1642",
    warning: "#ffbb38",
    info: {
        base: swatch.grey.lighter,
        dark: swatch.grey.dark,
    },
    background: {
        base: swatch.white,
        alt: swatch.grey.lighter,
        hover: swatch.grey.light,
    },
    border: {
        base: swatch.grey.light,
        dark: "#979797",
        darker: swatch.grey.darker,
    },
    disabled: {
        lighter: swatch.grey.lighter,
        light: swatch.grey.light,
        base: swatch.grey.base,
        dark: swatch.grey.dark,
    },
    text: {
        lighter: swatch.grey.base,
        light: swatch.grey.dark,
        base: swatch.grey.darker,
    },
    link: {
        base: "#1b43f5",
        hover: "#000182",
    },
    shadow: {
        light: "rgba(48, 49, 51, 0.05)",
        base: "rgba(48, 49, 51, 0.1)",
    },
    pagination: {
        base: swatch.grey.light,
        hover: Color(swatch.grey.light).darken(0.15).hex(),
    },
    footer: {
        base: "#eef2f6",
        bottom: "#dee5eb",
    },
    outline: "#09f",
};

export default {
    primary: {
        main: COLORS.primary.base,
        contrast: COLORS.white,
        // Custom
        light: COLORS.primary.light,
        dark: COLORS.primary.dark,
    },
    secondary: {
        main: COLORS.secondary.base,
        contrast: COLORS.white,
        // Custom
        light: COLORS.secondary.light,
        dark: COLORS.secondary.dark,
    },
    quinary: {
        // Custom
        main: COLORS.quinary.base,
        light: COLORS.quinary.light,
        contrast: COLORS.white,
    },
    common: {
        background: COLORS.white,
        backgroundContrast: COLORS.text.base,
        accent: COLORS.background.alt,
        accentContrast: COLORS.text.base,
        border: COLORS.border.base,
        disabled: COLORS.disabled.base,
        // Custom
        disabledLighter: COLORS.disabled.lighter,
        disabledLight: COLORS.disabled.light,
        disabledDark: COLORS.disabled.dark,
        borderDark: COLORS.border.dark,
        borderDarker: COLORS.border.darker,
        backgroundHover: COLORS.background.hover,
        outline: COLORS.outline,
    },
    text: {
        main: COLORS.text.base,
        disabled: COLORS.text.lighter,
        accent: COLORS.text.light,
        link: COLORS.link.base,
        // Custom
        linkHover: COLORS.link.hover,
    },
    success: {
        main: COLORS.success.base,
        contrast: COLORS.white,
        light: COLORS.success.light,
    },
    danger: {
        main: COLORS.error,
        contrast: COLORS.white,
    },
    warning: {
        main: COLORS.warning,
        contrast: COLORS.white,
    },
    info: {
        main: COLORS.info.base,
        contrast: COLORS.text.base,
    },
    // Custom
    pagination: {
        main: COLORS.pagination.base,
        hover: COLORS.pagination.hover,
    },
    footer: {
        main: COLORS.footer.base,
        contrastMain: COLORS.text,
        bottom: COLORS.footer.bottom,
    },
    header: {
        main: COLORS.white,
        contrastMain: COLORS.text,
        cartButtonBackground: COLORS.secondary.base,
        mainNavBackground: "transparent",
        mainNavBorder: COLORS.border.base,
        mainNavText: COLORS.primary.base,
        drawerAccent: COLORS.primary.base,
        top: `linear-gradient(to right, ${COLORS.secondary.base} 0%, ${COLORS.primary.base} 100%)`,
        topContrast: COLORS.white,
    },
};
